import React from 'react';
import { InlineImage } from '../../inline-image/inline-image.js';
import './carousel-button.css';
function CarouselButton(props) {
    const { icon, onClick } = props;
    return (React.createElement("button", { className: "c-carousel-button", onClick: onClick, "x-contrast": "bg" },
        React.createElement(InlineImage, { className: "c-carousel-button__icon", src: icon })));
}
export { CarouselButton, };
//# sourceMappingURL=carousel-button.js.map